export default __webpack_public_path__ + "static/media/cpr11.f673aa3e.jpg";